import script from "./ViewPDF.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPDF.vue?vue&type=script&setup=true&lang=js"

import "./ViewPDF.vue?vue&type=style&index=0&id=71b2933f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b2933f"]])

export default __exports__